import { Trash2 } from "lucide-react";
import toast from "react-hot-toast";
import { useMS } from "src/components/files/onedrive/context/MSContext";
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel } from "src/components/ui/alert-dialog";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/components/ui/tooltip";
import { deleteItemFromOneDrive } from "src/graph";

type P = {
    selected_documents: string[]
    onSuccess?: () => void
}

const RemoveFromDrive = ({selected_documents, onSuccess}:P) => {
    const { accessToken } = useMS()

    async function handleRemoveDocuments () {
        try {
            const deletePromises = selected_documents.map(async (id) => {
                await deleteItemFromOneDrive(accessToken, id);  
            });
            await Promise.all(deletePromises);
            toast.success(`${selected_documents.length} documenten verwijderd`, {id:'delete'})
            onSuccess && onSuccess();
        } catch (error:any) {
            console.log(error);
            toast.error(error.message, {id:'delete'});
        }
    }

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                <div>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild><button disabled={selected_documents.length < 1} className='w-8 h-8 rounded-sm flex items-center justify-center border border-solid border-transparent hover:border-neutral-200 hover:bg-neutral-100 disabled:opacity-30'><Trash2 className='w-4 h-4 text-red-600'/></button></TooltipTrigger>
                            <TooltipContent><p>Document verwijderen uit OneDrive</p></TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Let op! Documenten verwijderen</AlertDialogTitle>
                    <AlertDialogDescription>U staat op het punt om {selected_documents.length} document{selected_documents.length > 1 && 'en'} te verwijderen uit OneDrive</AlertDialogDescription>
                </AlertDialogHeader>

                <AlertDialogFooter>
                    <AlertDialogCancel>Annuleren</AlertDialogCancel>
                    <AlertDialogAction onClick={()=>{handleRemoveDocuments()}}>Verwijderen</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export { RemoveFromDrive }